<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="Trainer Report">
        <v-card-component>
          <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
            <v-col cols="3">
              <v-autocomplete  v-model="trainerList.id" class="my-0 py-1" label="Trainer Name" name="sTrainer" :items="trainerList"
              item-text="trainerFullName" item-value="id" key="id" @change="getAllTrainerReportList()"> </v-autocomplete>

            </v-col>

            <v-text-field
              :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
              v-model="search"
              append-icon="mdi-magnify"
              class="ml-auto mb-2"
              label="Search"
              hide-details
              single-line
              style="max-width:350px;"
              @input="searchHandler()"
            />
          </v-card-text>
          <v-divider class="my-0" />
          <v-data-table
            v-if="trainerData.length"
            :headers="tableHeaders"
            :items="trainerData"
            :footer-props="{
              'items-per-page-options': [5, 10, 20, 40]
            }"
            :items-per-page="10"
            disable-pagination
            :hide-default-footer="true"
            :search="search"
            item-key="srno"
          >

            <template v-slot:item.fromDate="{ item }">
              {{ formatDate(item.trainingDetails.fromDate) }}
            </template>
            <template v-slot:item.registrations="{ item }">
              {{ item.trainingDetails.totalRegistrations.length + '/' + item.trainingDetails.batchSize }}
            </template>
            <template v-slot:item.companyName="{ item }">
              {{ item.trainingDetails.trainingLocation ? item.trainingDetails.trainingLocation.companyName : 'NA' }}
            </template>
            <template v-slot:item.action="{ item }">
              <router-link slot="right" :to="{ name: 'indiviualTrainerFeedbackReport', params: { trainingID: item.trainingID , trainerID:item.user.id} }">
                <v-btn class="px-2 ml-1 ma-1" color="info" min-width="0" small>View</v-btn>
              </router-link>
            </template>

            <template v-slot:no-data>
              <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
            </template>
          </v-data-table>
          <!--Pagination start-->
          <v-row>
            <!-- <v-col cols="4" sm="3">
              <v-select v-model="pageSize" :items="pageSizes" label="Items per Page" @change="handlePageSizeChange"></v-select>
            </v-col> -->
            <v-col cols="12" sm="3">
              <v-pagination v-model="page" :length="totalPages" :total-visible="totalPages" @input="handlePageChange"> </v-pagination>
            </v-col>
          </v-row>
          <!--Pagination end-->
        </v-card-component>
      </material-card>
    </v-container>
  </div>
</template>
<script>
import VCardComponent from '@/components/template/VCardComponent'
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import moment from 'moment'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import Utils from '@/utils'
export default {
  name: 'allTrainerFeedbackReport',
  components: {
    MaterialCard,
    VCardComponent
  },
  data () {
    return {
      search: '',
      tableHeaders: [
        { text: 'SR.NO', value: 'srno', align: 'center', sortable: true },
        { text: 'Trainer Name', value: 'trainerName', sortable: false },
        { text: 'Training Title', value: 'trainingDetails.title', sortable: false },
        { text: 'Start Date', value: 'fromDate', sortable: false },
        { text: 'Registrations', value: 'registrations', sortable: false },
        { text: 'Location', value: 'companyName', sortable: false },
        { text: 'Type', value: 'trainingDetails.type', sortable: false },
        { text: 'Action', value: 'action', sortable: false }
      ],
      allTrainerReportList: [],
      page: 1,
      totalPages: 0,
      pageSize: 10,
      pageSizes: [5, 10, 20],
      trainerList: [],
      trainerName: '',
      trainerData: []
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee'
    })
  },
  created: function () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    this.getAllTrainerList()
  },
  mounted: async function () {
    await this.onFranchiseeChange()
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    }
    // page () {
    //   this.getAllTrainerReportList()
    // }
  },
  methods: {
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    getFiltered (e) {
      this.filterArr = e
    },
    columnValueList (val) {
      return this.trainingByTrainersList.map((d) => d[val])
    },
    onFranchiseeChange: async function () {
      if (this.franchisee) {
        this.franchiseeID = this.franchisee.id
      } else {
        this.franchiseeID = ''
      }
      await this.getAllTrainerReportList()
    },
    getAllTrainerReportList: async function () {
      try {
        const { data } = await http.post(`${constants.API_URL}/api/teacher-training/feedback/get/traininer-reports`, {
          page: this.page - 1,
          size: this.pageSize,
          search: '',
          franchiseeID: this.franchiseeID,
          trainerUserId: this.trainerList.id
        })
        let training = _.groupBy(data.rows, 'id')
        let trainers = []
        data.rows.forEach((training) => {
          trainers = trainers.concat(training.trainingTrainerMaps)
        })
        trainers = trainers.map((item, index) => {
          item.srno = this.pageSize * (this.page - 1) + index + 1
          item.trainerName = item.user.firstName + ' ' + item.user.lastName
          item.trainingDetails = training[item.trainingID][0]
          return item
        })
        this.trainerData = trainers
        this.totalPages = data.totalPages
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Datas: ${errorMessage}`)
      }
    },

    getAllTrainerList: async function () {
      try {
        this.isLoading = true

        let { data } = await http.get(`${constants.API_URL}/api/teacher-training/trainer-options`)
        this.isLoading = false
        this.trainerList = data
        this.trainerList = this.trainerList.map((item) => {
          let firstName = item.firstName
          let lastName = item.lastName
          item.trainerFullName = firstName + ' ' + lastName
          return item
        })
        if (this.trainerList.length > 1) {
          this.trainerList = [{ id: '', trainerFullName: 'Select All' }].concat(this.trainerList)
        } else {
          this.trainerList = data
        }
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    formatDate (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    handlePageChange: function () {
      this.getAllTrainerReportList()
    },
    handlePageSizeChange: function () {
      this.getAllTrainerReportList()
    },
    searchHandler: function () {
      if (this.search.length > 3) {
        this.getAllTrainerReportList()
      }
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
